import React from "react";
import { Box } from "@chakra-ui/react";
import { accent } from "../../constants/constants";

interface LogoProps {
  size?: string | number;
}

// Original geometric "A" monogram: two bold strokes for the legs in the
// site's text color, joined by an accent-colored crossbar.
const Logo: React.FC<LogoProps> = ({ size = "32px" }) => {
  return (
    <Box
      as="svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M22 88 L50 14"
        stroke="currentColor"
        strokeWidth="13"
        strokeLinecap="round"
      />
      <path
        d="M50 14 L78 88"
        stroke="currentColor"
        strokeWidth="13"
        strokeLinecap="round"
      />
      <path
        d="M33 58 L67 58"
        stroke={accent}
        strokeWidth="13"
        strokeLinecap="round"
      />
    </Box>
  );
};

export default Logo;
